export default {
  SEARCH_ALLIANZ_REQUEST_FOR_MOVEMENTS_TO_POLICY_QUERY: Symbol.for('SEARCH_ALLIANZ_REQUEST_FOR_MOVEMENTS_TO_POLICY_QUERY'),
  ALLIANZ_REQUEST_FOR_MOVEMENTS_TO_POLICY_REPOSITORY: Symbol.for('ALLIANZ_REQUEST_FOR_MOVEMENTS_TO_POLICY_REPOSITORY'),
  UPDATE_ACCOUNT_NUMBER_STATE_MANAGER: Symbol.for('UPDATE_ACCOUNT_NUMBER_STATE_MANAGER'),
  UPDATE_ACCOUNT_NUMBER_STATUS_SUBSCRIPTION: Symbol.for('UPDATE_ACCOUNT_NUMBER_STATUS_SUBSCRIPTION'),
};
